export var AutoResizeColumns;
(function (AutoResizeColumns) {
    AutoResizeColumns[AutoResizeColumns["Always"] = 0] = "Always";
    AutoResizeColumns[AutoResizeColumns["Once"] = 1] = "Once";
    AutoResizeColumns[AutoResizeColumns["Never"] = 2] = "Never";
})(AutoResizeColumns || (AutoResizeColumns = {}));
//# sourceMappingURL=easy_grid_options.js.map